import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.min.css';
import { Austria } from "flatpickr/dist/l10n/at.js"

export default class ContactBar {
    static selectorString()
    {
        return '.ContactBar';
    }

    constructor(rootNode)
    {
        const allClasses ='.contentContact, .contentArrival, .contactCta, .arrivalCta, .desktopContactCta, .desktopArrivalCta';
        const classes ='.contentContact, .contentArrival, .contactCta, .arrivalCta';
        const desktopClasses ='.contentContact, .contentArrival, .desktopContactCta, .desktopArrivalCta';

        callBackService(allClasses)
        toggleBar('.desktopContactCta', '.contentContact', desktopClasses, allClasses)
        toggleBar('.desktopArrivalCta', '.contentArrival', desktopClasses, allClasses)
        toggleMobileBar('.contactCta', '.contentContact', classes)
        toggleMobileBar('.arrivalCta', '.contentArrival', classes)

        jQuery('.desktopContactClose').click(function () {
            const margin = 'right';
            const value = jQuery('.contentContact').width();
            closeBar('.desktopContactCta', '.contentContact', desktopClasses, margin, value)
        });
        jQuery('.desktopArrivalClose').click(function () {
            const margin = 'right';
            const value = jQuery('.contentArrival').width();
            closeBar('.desktopArrivalCta', '.contentArrival', desktopClasses, margin, value)
        });
        jQuery('.contactClose').click(function () {
            const margin = 'bottom';
            const value = 550;
            closeBar('.contactCta', '.contentContact', classes, margin, value)
        });
        jQuery('.arrivalClose').click(function () {
            const margin = 'bottom';
            const value = 550;
            closeBar('.arrivalCta', '.contentArrival', classes, margin, value)
        });

        function toggleBar(button, content, classes, allClasses)
        {
            const slider_width = jQuery(content).width();//get width automatically
            jQuery(button).click(function () {
                if( jQuery(".contactBarMap .replaceWithIframe").length >= 1 ) {
                    let elementToReplace = jQuery(".contactBarMap .replaceWithIframe").first();
                    elementToReplace.replaceWith('<iframe src="' + elementToReplace.data('url') + '" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>');
                }
                if (jQuery(this).css("margin-right") === slider_width+"px" && !jQuery(this).is(':animated')) {
                    resetToFixed();
                    if (jQuery(this).closest('.tabHeader').hasClass('revert')) {
                        jQuery(classes).animate({"margin-right": '-='+slider_width}, {duration: 500});
                        jQuery(this).closest('.tabHeader').removeClass('revert')
                        jQuery('.contactOverlay').fadeOut();
                        jQuery(content).removeClass('tabActive');
                        jQuery(content).fadeOut();
                    } else {
                        jQuery('.tabHeader').removeClass('revert');
                        jQuery(this).closest('.tabHeader').addClass('revert')
                        jQuery('.tabActive').fadeOut().removeClass('tabActive');
                        jQuery(content).addClass('tabActive');
                        jQuery(content).fadeIn();
                    }
                } else {
                    if (!jQuery(this).is(':animated') && (jQuery(content).css('margin-right') === '-' + slider_width + 'px')) {//perevent double click to double margin
                        jQuery(content).addClass('tabActive');
                        jQuery(this).closest('.tabHeader').addClass('revert')
                        jQuery(content).show(100, function () {
                            jQuery(classes).animate({"margin-right": '+='+slider_width}, {duration: 500});
                            jQuery('.contactOverlay').fadeIn();
                        });
                    }
                }
            });
        }

        function toggleMobileBar(button, content, classes)
        {
            const sliderHeight = jQuery(content).height();//get width automaticly
            jQuery(button).click(function () {
                resetToFixed()
                if( jQuery(".contactBarMap .replaceWithIframe").length >= 1 ) {
                    let elementToReplace = jQuery(".contactBarMap .replaceWithIframe").first();
                    elementToReplace.replaceWith('<iframe src="' + elementToReplace.data('url') + '" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>');
                }
                if (jQuery(this).css("margin-bottom") === sliderHeight+"px" && !jQuery(this).is(':animated')) {
                    if (jQuery(this).closest('.tabHeader').hasClass('revert')) {
                        jQuery(classes).animate({"margin-bottom": '-='+sliderHeight}, {duration: 500});
                        jQuery(this).closest('.tabHeader').removeClass('revert')
                        jQuery('.contactOverlay').fadeOut();
                        jQuery(content).removeClass('tabActive');
                        jQuery(content).fadeOut();
                    } else {
                        jQuery('.tabHeader').removeClass('revert');
                        jQuery(this).closest('.tabHeader').addClass('revert')
                        jQuery('.tabActive').fadeOut().removeClass('tabActive');
                        jQuery(content).addClass('tabActive');
                        jQuery(content).fadeIn();
                    }
                } else {
                    if (!jQuery(this).is(':animated')) {//perevent double click to double margin
                        jQuery(content).show();
                        jQuery(content).addClass('tabActive');
                        jQuery(classes).animate({"margin-bottom": '+='+sliderHeight}, {duration: 500});
                        jQuery(this).closest('.tabHeader').addClass('revert')
                        jQuery('.contactOverlay').fadeIn();
                    }
                }
            });
        }

        function callBackService(allClasses)
        {
            const $ = jQuery;
            const contactBar = $('.ContactBar');

            $('.callBackCta').click(function (event) {
                if (contactBar.css('position') === 'fixed') {
                    contactBar.css({
                        position: 'absolute',
                        top: $(window).scrollTop() + 193+'px'
                    });
                    $('.desktopArrivalCta').css({
                        top: 123+'px'
                    });
                    $('.contentContact, .contentArrival').css({
                        height: 'initial',
                        bottom: 'initial'
                    });
                    $(allClasses).css({
                        position: 'absolute',
                        'margin-bottom': 'initial'
                    });
                } else {
                    contactBar.css({
                        position:'fixed',
                        top: '193px'
                    });
                    $('.desktopArrivalCta').css({
                        top: ''
                    });
                    $(allClasses).css({
                        position: 'fixed',
                    });
                    $('.contentContact, .contentArrival').css({
                        height: '',
                        bottom: '',
                    });
                        $('.contactCta, .arrivalCta').css({
                            'margin-bottom': jQuery('.contentContact').height()
                        });
                }
                $('.arrow').toggleClass('active');
                $('#callBackWrap').slideToggle(500);
            })

            const calendar = $('#callback-calendar');
            $('#type').change(function () {
                if ($(this).val() === 'date') {
                    if (!calendar.hasClass('flatpickr-input')) {
                        initializeCalendar(calendar);
                    }
                    calendar.prop('required', true);
                    calendar.show();
                } else {
                    calendar.prop('required', false);
                    calendar.hide()
                }
            })
        }

        function initializeCalendar(calendar)
        {
            const disabledDays = calendar.attr('data-disable');
            let disabledIndexes = null;
            let disabled = [];
            if (disabledDays && disabledDays.length > 0) {
                disabledIndexes = disabledDays.split(',');
                disabled = disabledIndexes.map(function (x) {
                    return +x;
                });
            }
            const options = {
                "disable": [
                function (date) {
                    return (disabled.includes(date.getDay()));
                }
                ],
                "locale": {
                    "firstDayOfWeek": 1
                },
                minDate: "today",
                dateFormat: "d.m.Y"
            }
            flatpickr.localize(Austria);
            flatpickr('.calendar', options);
            calendar.on('focus', ({ currentTarget }) => jQuery(currentTarget).blur());
            calendar.prop('readonly', false);
        }

        function closeBar(buttonClass, contentClass, classes, marginType, value)
        {
            const animation = {};
            resetToFixed();
            animation['margin-' + marginType] = '-='+value;
            jQuery(classes).animate(animation, {duration: 500});
            jQuery(classes).removeClass('tabActive');
            jQuery(contentClass).fadeOut();
            jQuery(buttonClass).closest('.tabHeader').removeClass('revert')
            jQuery('.contactOverlay').fadeOut();
        }

        function resetToFixed()
        {
            const contactBar = jQuery('.ContactBar');
            if (contactBar.css('position') !== 'fixed') {
                jQuery('.callBackCta').trigger('click');
            }
        }
    }
}
